<template>
    <div class="lookfor">
        <Head :index="'7'"></Head>
        <div class="chartTop">
            <div>查找共祖</div>
        </div>
        <div class="main">
            <div class="fl">
               <!--  <table class="fltable">
                    <tr>
                        <td><el-input type="text" class="member" v-model="name1" autocomplete="off" placeholder="成员1"></el-input></td>
                        <td><el-input type="text" class="member" v-model="fathername1" autocomplete="off" placeholder="成员1父亲"></el-input></td>

                    </tr>
                    <tr>
                        <td><el-input type="text" class="member" v-model="name2" autocomplete="off" placeholder="成员2"></el-input></td>
                        <td><el-input type="text" class="member" v-model="fathername2" autocomplete="off" placeholder="成员2父亲"></el-input></td>

                    </tr>
                    <tr>
                        <td><el-input type="text" class="member" v-model="name3" autocomplete="off" placeholder="成员3"></el-input></td>
                        <td><el-input type="text" class="member" v-model="fathername3" autocomplete="off" placeholder="成员3父亲"></el-input></td>

                    </tr>
                    <tr>
                        <td><el-input type="text" class="member" v-model="name4" autocomplete="off" placeholder="成员4"></el-input></td>
                        <td><el-input type="text" class="member" v-model="fathername4" autocomplete="off" placeholder="成员4父亲"></el-input></td>

                    </tr>
                    <tr>
                        <td><el-input type="text" class="member" v-model="name5" autocomplete="off" placeholder="成员5"></el-input></td>
                        <td><el-input type="text" class="member" v-model="fathername5" autocomplete="off" placeholder="成员5父亲"></el-input></td>

                    </tr>
                    <tr>
                        <td><el-input type="text" class="member" v-model="name6" autocomplete="off" placeholder="成员6"></el-input></td>
                        <td><el-input type="text" class="member" v-model="fathername6" autocomplete="off" placeholder="成员6父亲"></el-input></td>
                    </tr>
                </table> -->
                <table class="fltable">
                    <tr v-for="(item, index) in info" :key="index">
                        <td><el-input type="text" class="member" v-model="item.name" autocomplete="off" :placeholder="'成员'+(index+1)"></el-input></td>
                        <td><el-input type="text" class="member" v-model="item.fathername" autocomplete="off" :placeholder="'成员'+(index+1)+'父亲'"></el-input></td>
                        <td style="width:40px" v-if="index === info.length - 1 && info.length < 10">
                            <el-button type="primary" size="small" @click="add()" style="width:40px">+</el-button>
                        </td>
                    </tr>
                </table>
                <el-button @click="searchClick()" type="primary" size="small" style="margin:10px 0">查找共祖</el-button>
            </div>
            <div class="fr" ref="chart">
                <!-- <orgtree :data="data" v-if="data != {}" @NodeClick="NodeClick"></orgtree> -->
                <!-- <span>暂无</span> -->
                <!-- <div id="treeEcharts" style="width: 100%, height: 1000px" ref="treeEcharts"></div> -->
                <!-- <div v-for="(item, index) in data" :key="index">
                {{ item.xm }}
            </div> -->
                <div id="treeEcharts" style="margin:0 0 0 20px" ref="treeEcharts"></div>
            </div>
        </div>
    </div>
</template>
<script>
import Head from "@/components/header.vue";
// import orgtree from "@/components/orgtree.vue";
import api from "@/request/api";
export default {
    data() {
        return {
            /* fathername1: "孙瑞祥",
            name1: "孙长浩",
            fathername2: "孙守民",
            name2: "孙中锋",
            fathername3: "孙汉池",
            name3: "孙惠",
            fathername4: "",
            name4: "",
            fathername5: "",
            name5: "",
            fathername6: "",
            name6: "", */
            info:[],
            data: [],
            echartsInit: null
        };
    },
    mounted() {},
    methods: {
        add(){
            this.info.push({"name":"","fathername":""});
        },
        getList() {
            api.familyList().then((res) => {
                this.tableData = res.data;
            });
        },

        submitForm() {},
        NodeClick(e, data) {
            if (e.srcElement.localName == "div") {
            }
        },
        searchClick() {
            // "fid=1&name=" + this.name + "&fathername=" + this.fathername
            console.log(this.info,'---------this.info')

            api.memberFindbothancestor({"fid":localStorage.getItem("fid"),"names":this.info}
                ).then((res) => {
                if (res.code == 0) {
                    this.data = res.data;
                    this.echartsFun();
                } else {
                    this.data = [];//清空
                    this.echartsFun();
                    // alert(111)
                  /*   this.$message({
                        message: res.msg,
                        type: "warning"
                    }); */
                }
            });
           /*  api.memberFindbothancestor(
                this.$qs.stringify({
                    fid: localStorage.getItem("fid"),
                    name1: this.name1,
                    fathername1: this.fathername1,
                    name2: this.name2,
                    fathername2: this.fathername2,
                    name3: this.name3,
                    fathername3: this.fathername3,
                    name4: this.name4,
                    fathername4: this.fathername4,
                    name5: this.name5,
                    fathername5: this.fathername5,
                    name6: this.name6,
                    fathername6: this.fathername6
                })
            ).then((res) => {
                if (res.code == 0) {
                    // this.data = res.data[0];
                    this.data = res.data;
                    this.echartsFun();
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            }); */
        },
        echartsFun() {
            var that = this;
            this.echartsInit = this.$echarts.init(this.$refs.treeEcharts);
            // this.echartsInit = this.$echarts.init(document.getElementById("treeEcharts"));
            // this.echartsInit.removeAttribute("_echarts_instance_");
            // this.echartsInit = this.$echarts.init(document.getElementById("treeEcharts"));
            let treeData = this.data;
            this.echartsInit.clear();
            this.echartsInit.setOption({
                title: {
                    show: false
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 1,
                            title: "保存为图片 ",
                            type: "png",
                            lang: ["点击保存"],
                            emphasis: {
                                iconStyle: {
                                    textPosition: "left"
                                }
                            }
                        }
                    }
                },
                // dataZoom: [{ 
                //     type: "inside", // 这里可以选择你需要的dataZoom类型
                //     start: 0, // 默认数据初始选择范围为100%
                //     end: 100 // 默认数据初始选择范围为100%
                // }],
                series: [
                    {
                        type: "tree",
                        data: treeData,
                        left: "2%",
                        right: "2%",
                        top: "5%",
                        bottom: "20%",
                        symbol: "emptyCircle",
                        orient: "vertical",
                        edgeShape: "polyline",
                        expandAndCollapse: true,
                        // roam: false,
                        roam: true,
                        scaleLimit: { //滚轮缩放的极限控制
                            min: 0.5,
                            max: 5
                        },
                        zoom: 1, //当前视角的缩放比例
                        initialTreeDepth: -1,
                        expandAndCollapse: false,
                        nodePadding: 10, //节点间距
                        layerPadding: 10, //层间距
                        lineStyle: {
                            //正常情况显示
                            color: "red",
                            width: 2
                        },
                        label: {
                            verticalAlign: "middle",
                            show: true,
                            padding: [15, 0],
                            width: 100, //尺寸大小 150
                            height: 50,//60
                            borderRadius: 10,
                            borderColor: "red",
                            color: "#000000",
                            align: "center",
                            formatter: function(params) {
                                params.data.label = {
                                    backgroundColor: "red"
                                };
                                params.data.label.backgroundColor = params.data.sex == 1 ? "#ffabd5" : "#96d5ff";
                                if (params.data.sgzt == 1) {
                                    params.data.label.borderWidth = 2;
                                    params.data.label.borderColor = "#000";
                                }
                                return (
                                    (params.data.ph != 0 ? "{a|" + that.ph(params.data.ph) + "} " : "") +
                                    "{b|" +
                                    params.data.xm +
                                    "}\n{c|" +
                                    (params.data.dc != "" && params.data.dc != null ? params.data.dc : "未知") +
                                    // (params.data.sr != "" && params.data.sr != null ? String(params.data.sr).split("-")[0] : "未知") +
                                    " - " +
                                    (params.data.jc != "" && params.data.jc != null ? params.data.jc : "至今") +
                                    // (params.data.qssj != "" && params.data.qssj != null ? String(params.data.qssj).split("-")[0] : "至今") +
                                    "}\n{x|" +
                                    that.toChies(params.data.shixu) +
                                    "世}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 10,
                                    borderWidth: 1,
                                    borderColor: "#000",
                                    borderRadius: 50,
                                    padding: 3,
                                    verticalAlign: "top",
                                    align: "center",
                                    lineHeight: 20
                                },
                                b: {
                                    fontSize: 16,
                                    margin: [10, 20]
                                },
                                c: {
                                    fontSize: 12,
                                    color: "#878787",
                                    lineHeight: 30
                                },
                                x: {
                                    fontSize: 12,
                                    color: "#fff"
                                }
                            }
                        },
                        leaves: {
                            label: {
                                verticalAlign: "middle",
                                align: "center"
                            }
                        },
                        animationDurationUpdate: 250
                    }
                ]
            });

            const getLevel = (arr) => {
                let maxLevel = 0;
                (function callBack(arr, level) {
                    ++level;
                    maxLevel = Math.max(level, maxLevel);
                    for (let i = 0; i < arr.length; i++) {
                        let item = arr[i];
                        if (item.children && item.children.length > 0) {
                            callBack(item.children, level);
                        } else {
                            delete item.children;
                        }
                    }
                })(arr, 0);
                return maxLevel;
            };
            function getMaxFloor(arr) {
                let maxLevel = [];
                (function callBack(arr, level) {
                    for (let i = 0; i < arr.length; i++) {
                        let item = arr[i];
                        if (item.children && item.children.length > 0) {
                            callBack(item.children, level);
                        } else {
                            maxLevel.push(item);
                        }
                    }
                })(arr, 0);
                return maxLevel;
            }

            const height = window.innerHeight;
            const width = window.innerWidth;
            const currentHeight = 170 * getLevel(treeData);
           
            let currentWidth = 190 * getMaxFloor(treeData).length;
            if (currentWidth > width - 400) {
                // currentWidth = 190 * getMaxFloor(treeData).length;
                currentWidth = 410;
            }
            const newHeight = Math.max(currentHeight, height - 115);
            // const newWidth = Math.max(currentWidth, width - 400);
            const tree_ele = document.getElementById("treeEcharts");

            console.log(getMaxFloor(treeData).length,'---getMaxFloor(treeData).length');
            console.log(currentHeight,'---currentHeight');
            console.log(width,'---width');
            console.log(currentWidth,'---currentWidth');
            console.log(newHeight,'---newHeight');
            tree_ele.style.height = newHeight + "px";
            tree_ele.style.width = currentWidth + "px";
            tree_ele.style.overflow = "auto";

            this.echartsInit.resize();

            this.echartsInit.on("treeroam", function(params) {
                // 控制台打印数据的名称
                if (params.originX || params.originY) {
                    let zoom = params.zoom;
                    let _option = that.echartsInit.getOption(); //获取最新的option配制
                    let series = _option.series[0];
                    series.label.padding[0] = series.label.padding[0] * zoom;
                    series.label.padding[1] = series.label.padding[1] * zoom;
                    series.label.height = series.label.height * zoom;
                    series.label.width = series.label.width * zoom;
                    series.label.borderRadius = series.label.borderRadius * zoom;
                    series.label.rich.a.fontSize = series.label.rich.a.fontSize * zoom;
                    series.label.rich.a.lineHeight = series.label.rich.a.lineHeight * zoom;
                    series.label.rich.a.padding = series.label.rich.a.padding * zoom;
                    series.label.rich.b.fontSize = series.label.rich.b.fontSize * zoom;
                    series.label.rich.b.margin[0] = series.label.rich.b.margin[0] * zoom;
                    series.label.rich.b.margin[1] = series.label.rich.b.margin[1] * zoom;
                    series.label.rich.c.fontSize = series.label.rich.c.fontSize * zoom;
                    series.label.rich.c.lineHeight = series.label.rich.c.lineHeight * zoom;
                    series.label.rich.x.fontSize = series.label.rich.x.fontSize * zoom;
                    that.echartsInit.setOption(_option); //更新修改后的option配制
                }
            });
        }
    },
    computed: {
        ph(val) {
            return function(val) {
                let ph = "";
                for (let i = 0; i < this.$store.state.phData.length; i++) {
                    if (val == this.$store.state.phData[i].val) {
                        ph = this.$store.state.phData[i].key;
                    }
                }
                return ph;
            };
        },
        toChies(val) {
            return function(val) {
                return this.$utils.toChies(val);
            };
        }
    },
    components: {
        Head
        // orgtree
    }
};
</script>

<style lang="less" scoped>
.lookfor {
    height: 100%;

    .chartTop {
        height: 55px;
        line-height: 55px;
        padding:0 20px;

        h1 {
            width: 350px;
            font-size: 20px;
        }
    }
    .fltable tr td {
        height: 50px;
        width: 120px;
    }
    .main {
        height: 100%;
        padding:0 20px;
        .fl{
            width: 100%;
            box-sizing: border-box;
            font-size: 14px;
            /deep/.el-input {
                display: inline-block;
                width: 105px;
                right: 0;
                .el-input__inner {
                    border-width: 3px !important;
                    font-size: 14px;
                }
            }
            .member {
                margin-right: 15px;
                border-width: 1px;
                /deep/.el-input__inner {
                    border-width: 1px !important;
                }
            }
            span {
                display: inline-block;
            }
            button {
                margin: 0 auto;
                width: 80px;
                display: block;
            }
        }
        .main-left {
            padding: 0 70px 0 25px;
            box-sizing: border-box;
            .el-input {
                display: inline-block;
                width: 78px;
                margin-bottom: 20px;
                right: 0;
                .el-input__inner {
                    height: 30px;
                    line-height: 30px;
                }
            }
            span {
                display: inline-block;
            }
            button {
                margin: 0 auto;
                width: 80px;
                display: block;
            }
        }
        .main-right {
            text-align: center;
            overflow: auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/cancestor.vue